<div
  class="content-box content-box--{{ theme }} {{ borderRadius }} {{ padding }} base-border {{ selected ? 'content-box--' + theme + '--selected' : '' }}"
  [class.base-shadow]="withShadow"
>
  <ng-content />
</div>
